module.exports = __webpack_public_path__ + "images/clearday.5aa15a62573489deb5684c0560768328.png";